export default {
  methods: {
    setStoredLanguage() {
      const languageStored = window.localStorage.getItem("tomin-language");
      if (languageStored) {
        this.$i18n.locale = languageStored;
      }
      return languageStored || "en-US";
    }
  }
};
